import React, { useEffect } from "react";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Divider from "@material-ui/core/Divider";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { grey } from "@material-ui/core/colors";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SettingIcon from "@material-ui/icons/Settings";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import "../../../public/css/style.less";
import "./SideNav.less";
import { NavLink, useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { IsSectionVisible } from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import ContactsOutlined from "@material-ui/icons/ContactsOutlined";
import RadioOutlined from "@material-ui/icons/RadioOutlined";
import EmailOutlined from "@material-ui/icons/EmailOutlined";
import { IconButton } from "@material-ui/core";
import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import Badge from "../../../public/img/common/securityBadge.svg";
import ScreenSearchDesktopOutlinedIcon from "@material-ui/icons/PageviewOutlined";
import WelcomeLogo from "../../../public/img/common/welcome.jpg";

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex"
	},
	appBar: {
		zIndex: theme.zIndex.drawer + 1,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		})
	},
	appBarShift: {
		marginLeft: drawerWidth,
		width: `calc(100% - ${drawerWidth}px)`,
		transition: theme.transitions.create(["width", "margin"], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	menuButton: {
		marginRight: 36
	},
	hide: {
		display: "none"
	},
	drawer: {
		width: drawerWidth,
		flexShrink: 0,
		whiteSpace: "nowrap"
	},
	drawerOpen: {
		width: drawerWidth,
		backgroundColor: "#064473",
		color: "#FFFFFF",
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	drawerClose: {
		backgroundColor: "#064473",
		color: "#FFFFFF",
		transition: theme.transitions.create("width", {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen
		}),
		overflowX: "hidden",
		width: theme.spacing(7) + 1,
		[theme.breakpoints.up("sm")]: {
			width: theme.spacing(9) + 1
		}
	},
	toolbar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		padding: theme.spacing(0, 1),
		// necessary for content to be below app bar
		...theme.mixins.toolbar
	},
	content: {
		flexGrow: 1,
		padding: theme.spacing(3)
	}
}));

/** Mini drawer function */
export default function MiniDrawer({ selectedTab }) {
	const classes = useStyles();
	const theme = useTheme();
	const [open, setOpen] = React.useState(false);
	const [selectedMenu, setSelected] = React.useState(selectedTab);
	const history = useHistory();
	const layout = "";
	const handleDrawerOpen = () => {
		setOpen(true);
	};
    
	const handleDrawerClose = selectedIndex => {
		if (selectedIndex != undefined) {
			setSelected(selectedIndex);
		}
		setOpen(false);
	};
	localStorage.setItem("isApiCalled","false");
	useEffect(() => {
		switch (history.location.pathname) {
			case "/Dashboard":
				setSelected(0);
				break;
			case "/tenant":
				setSelected(1);
				break;
			case "/request":
				setSelected(2);
				break;
			case "/communication":
				setSelected(3);
				break;
			case "/observation":
				setSelected(4);
				break;
			case "/kpi":
				setSelected(5);
				break;
			case "/configurations":
				setSelected(6);
				break;
			case "/reporting":
				setSelected(8);
				break;
			case "/securityIncident":
				setSelected(9);
				break;
			case "/sdcgrantaccess":
				setSelected(10);
				break;
			case "/apiKeyManagement":
					setSelected(1);
					break;
			case "/welcome":
					setSelected(11);
					break;
			default:
				break;
		}
	}, [history.location.pathname]);
	return (
		<div className={classes.root}>
			<CssBaseline />

			<Drawer
				variant={"permanent"}
				className={clsx(classes.drawer, {
					[classes.drawerOpen]: open,
					[classes.drawerClose]: !open
				})}
				classes={{
					paper: clsx({
						[classes.drawerOpen]: open,
						[classes.drawerClose]: !open
					})
				}}
			>
				<IconButton
					color={"inherit"}
					aria-label={"open drawer"}
					onClick={() => handleDrawerOpen()}
					className={
						"white-button " +
						clsx({
							[classes.hide]: open
						})
					}
				>
					<MenuIcon className={"white-button"} style={{ color: grey[50] }} />
				</IconButton>

				<span>
					<IconButton
						onClick={() => handleDrawerClose()}
						className={
							"white-button " +
							clsx({
								[classes.hide]: !open
							})
						}
					>
						{theme.direction === "rtl" ? (
							<ChevronRightIcon
								className={"white-button"}
								style={{ color: grey[50] }}
							/>
						) : (
							<ChevronLeftIcon
								className={"white-button"}
								style={{ color: grey[50] }}
							/>
						)}
					</IconButton>
				</span>
				<Divider />
				<List>
				{IsSectionVisible(SECTIONS.WELCOME) && (
						<NavLink
							onClick={() => handleDrawerClose(11)}
							to={layout + "/welcome"}
						>
							<ListItem button selected={selectedMenu == 11 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Welcome"} placement={"right"}>
										<img
											style={{
												width: "27px",
												height: "28px",
											}}
											src={WelcomeLogo}
											alt={"logo"}
										/>
									</Tooltip>
								</ListItemIcon>

								<ListItemText primary={"Welcome"} style={{ color: grey[50] }} />
							</ListItem>
						</NavLink>
					)}
					{IsSectionVisible(SECTIONS.DASHBOARD) && (
						<NavLink
							onClick={() => handleDrawerClose(0)}
							to={layout + "/Dashboard"}
						>
							<ListItem button selected={selectedMenu == 0 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Dashboard"} placement={"right"}>
										<DashboardOutlinedIcon style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText primary={"Dashboard"} style={{ color: grey[50] }} />
							</ListItem>
						</NavLink>
					)}
					{IsSectionVisible(SECTIONS.TENANT) && (
						<NavLink
							onClick={() => handleDrawerClose(1)}
							to={layout + "/tenant"}
						>
							<ListItem button selected={selectedMenu == 1 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Tenant"} placement={"right"}>
										<ContactsOutlined style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText primary={"Tenant"} style={{ color: grey[50] }} />
							</ListItem>
						</NavLink>
					)}
					{IsSectionVisible(SECTIONS.REQUEST) && (
						<NavLink
							onClick={() => handleDrawerClose(2)}
							to={layout + "/request"}
						>
							<ListItem button selected={selectedMenu == 2 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Request"} placement={"right"}>
										<RadioOutlined style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText primary={"Request"} style={{ color: grey[50] }} />
							</ListItem>
						</NavLink>
					)}

					{IsSectionVisible(SECTIONS.SDC_GRANT_ACCESS) && (
						<NavLink
							onClick={() => handleDrawerClose(10)}
							to={layout + "/sdcgrantaccess"}
						>
							<ListItem button selected={selectedMenu == 10 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"SDC Grant Access"} placement={"right"}>
										<ScreenSearchDesktopOutlinedIcon
											style={{ color: grey[50] }}
										/>
									</Tooltip>
								</ListItemIcon>

								<ListItemText
									primary={"SDC Grant Access"}
									style={{ color: grey[50] }}
								/>
							</ListItem>
						</NavLink>
					)}

					{IsSectionVisible(SECTIONS.COMMUNICATION) && (
						<NavLink
							onClick={() => handleDrawerClose(3)}
							to={layout + "/communication"}
						>
							<ListItem button selected={selectedMenu == 3 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Communication"} placement={"right"}>
										<EmailOutlined style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText
									primary={"Communication"}
									style={{ color: grey[50] }}
								/>
							</ListItem>
						</NavLink>
					)}

					{IsSectionVisible(SECTIONS.HSE_INCIDENT_MENU) && (
						<NavLink
							onClick={() => handleDrawerClose(4)}
							to={layout + "/observation"}
						>
							{" "}
							<ListItem button selected={selectedMenu == 4 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Health And Safety"} placement={"right"}>
										<LocalHospitalOutlinedIcon
											style={{ color: "red", width: "26px", fontSize: "27px" }}
										/>
									</Tooltip>
								</ListItemIcon>

								<ListItemText
									primary={"Health And Safety"}
									style={{ color: grey[50] }}
								/>
							</ListItem>
						</NavLink>
					)}
					{IsSectionVisible(SECTIONS.SECURITY_INCIDENT) && (
						<NavLink
							onClick={() => handleDrawerClose(9)}
							to={layout + "/securityIncident"}
						>
							{" "}
							<ListItem button selected={selectedMenu == 9 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Security Incident"} placement={"right"}>
										<img
											style={{
												width: "27px",
												height: "28px",
												filter: "brightness(0) invert(1)"
											}}
											src={Badge}
											alt={"logo"}
										/>
										{/* <SecurityOutlined
											style={{ color: grey[50], width: "26px", fontSize: "27px" }}
										/> */}
									</Tooltip>
								</ListItemIcon>

								<ListItemText
									primary={"Security Incident"}
									style={{ color: grey[50] }}
								/>
							</ListItem>
						</NavLink>
					)}
					{(IsSectionVisible(SECTIONS.FACILITY_PERFORMANCE) ||
						IsSectionVisible(SECTIONS.FINANCIAL) ||
						IsSectionVisible(SECTIONS.HEALTH_AND_SAFETY) ||
						IsSectionVisible(SECTIONS.MAINTENANCE) ||
						IsSectionVisible(SECTIONS.SECURITY_AND_OPERATION) ||
						IsSectionVisible(SECTIONS.SITE_PROFILE) ||
						IsSectionVisible(SECTIONS.STAFFING)) && (
						<NavLink onClick={() => handleDrawerClose(5)} to={layout + "/kpi"}>
							{" "}
							<ListItem button selected={selectedMenu == 5 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"KPI"} placement={"right"}>
										<AssessmentOutlinedIcon style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText primary={"KPI"} style={{ color: grey[50] }} />
								{/* {open ? <ExpandLess /> : <ExpandMore />} */}
							</ListItem>
						</NavLink>
					)}

					{IsSectionVisible(
						SECTIONS.REPORTING,
						SECTIONS.REPORTING,
						SECTIONS.ADD_EDIT
					) && (
						<NavLink
							onClick={() => handleDrawerClose(8)}
							to={layout + "/reporting"}
						>
							{" "}
							<ListItem button selected={selectedMenu == 8 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Reporting"} placement={"right"}>
										<AssignmentIcon style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText primary={"Reporting"} style={{ color: grey[50] }} />
							</ListItem>
						</NavLink>
					)}

					{IsSectionVisible(SECTIONS.CONFIGURATION) && (
						<NavLink
							onClick={() => handleDrawerClose(6)}
							to={layout + "/configurations"}
						>
							{" "}
							<ListItem button selected={selectedMenu == 6 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"Configuration Settings"} placement={"right"}>
										<SettingIcon style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText
									primary={"Configurations"}
									style={{ color: grey[50] }}
								/>
								{/* {open ? <ExpandLess /> : <ExpandMore />} */}
							</ListItem>
						</NavLink>
					)}

					{IsSectionVisible(SECTIONS.ABOUT_US) && (
						<NavLink
							onClick={() => handleDrawerClose(7)}
							to={layout + "/aboutUs"}
						>
							{" "}
							<ListItem button selected={selectedMenu == 7 ? true : false}>
								<ListItemIcon>
									<Tooltip title={"About Us"} placement={"right"}>
										<InfoIcon style={{ color: grey[50] }} />
									</Tooltip>
								</ListItemIcon>

								<ListItemText primary={"About Us"} style={{ color: grey[50] }} />
								{/* {open ? <ExpandLess /> : <ExpandMore />} */}
							</ListItem>
						</NavLink>
					)}
				</List>
			</Drawer>
		</div>
	);
}
